var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publicBanner"},[_c('div',{staticClass:"publicCon"},[_c('h3',{class:_vm.bannerInfo.content ? '' : 'single'},[_vm._v(_vm._s(_vm.bannerInfo.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.bannerInfo.content))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ede718c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicBanner/index.vue
// module id = null
// module chunks = 